/* eslint-disable no-alert */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */

import React, { useState } from 'react';

import axios from 'axios';

import {
  ButtonPurple,
  ButtonSend,
  ContainerImageInput,
  ContainerImages,
  ImageStrip,
  Input,
} from './style';

import secondStripPNG from '../../assets/images/pit-stop-promo/second-strip.png';
import firstStripPNG from '../../assets/images/pit-stop-promo/first-strip.png';
import thirdStripPNG from '../../assets/images/pit-stop-promo/third-strip.png';

const USERS_BASE_URL = process.env.REACT_APP_USERS_BASE_URL;

export default function PitStopPromo(): JSX.Element {
  const [email, setEmail] = useState('');

  function redirectToStore(): void {
    const userAgent: string = navigator.userAgent || navigator.vendor || (window as any).opera;

    const isAndroid: boolean = /android/i.test(userAgent);
    const isIOS: boolean = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
    const isWindows: boolean = /Win/i.test(userAgent);
    const isMac: boolean = /Mac/i.test(userAgent);

    if (isAndroid || isWindows) {
      window.location.href =
        'https://play.google.com/store/apps/details?id=com.guilu.appresolvaclub';
    } else if (isIOS || isMac) {
      window.location.href =
        'https://apps.apple.com/br/app/resolva-arm%C3%A1rio-digital/id1575252378';
    } else {
      alert(
        'Sistema operacional não identificado. Por favor, acesse a loja de aplicativos manualmente.'
      );
    }
  }

  const handleSend = async (event: React.FormEvent): Promise<void> => {
    event.preventDefault();

    try {
      await axios.post(`${USERS_BASE_URL}check-subscriptions/insert-username-for-promo`, {
        username: email,
        promo: 'Promoção Pit Stop',
      });

      alert('Tudo certo! Agora se cadastre no app com este mesmo email e aproveite os benefícios!');
    } catch (e) {
      if (e.response.data.sqlMessage.includes('Duplicate entry')) {
        alert('Email já registrado na promoção! Utilize outro email para prosseguir');
      } else {
        alert(
          `Ocorreu um erro ao registrar seu email. Por favor contate a central através do whatsapp: +55 (11) 93400-9574. ${e.response.data}`
        );
      }
    }
  };

  return (
    <ContainerImages>
      <form onSubmit={handleSend}>
        <ContainerImageInput style={{ position: 'relative' }}>
          <ImageStrip src={firstStripPNG} />
          <Input
            placeholder="E-mail"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            type="email"
            required
          />
          <ButtonSend type="submit">Enviar</ButtonSend>
        </ContainerImageInput>
      </form>
      <ContainerImageInput style={{ position: 'relative' }}>
        <ImageStrip src={secondStripPNG} />
        <ButtonPurple bottom="750px" onClick={redirectToStore}>
          Clique aqui!
        </ButtonPurple>
      </ContainerImageInput>
      <ContainerImageInput style={{ position: 'relative' }}>
        <ImageStrip src={thirdStripPNG} />
        <ButtonPurple bottom="270px" onClick={redirectToStore}>
          Baixe agora!
        </ButtonPurple>
      </ContainerImageInput>
    </ContainerImages>
  );
}
